import { render, staticRenderFns } from "./RakamTanimla.vue?vue&type=template&id=0ef853c2&scoped=true&"
import script from "./RakamTanimla.vue?vue&type=script&lang=js&"
export * from "./RakamTanimla.vue?vue&type=script&lang=js&"
import style0 from "./RakamTanimla.vue?vue&type=style&index=0&id=0ef853c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef853c2",
  null
  
)

export default component.exports